export { default } from './getPrefix'
export * from './getPrefix'
